import MiniFridge from 'minibar/assets/icons/refridgerator.svg'
import SittingArea from 'minibar/assets/icons/sitting-area.svg'
import LoungeChairs from 'minibar/assets/icons/tanning-edge.svg'

import { Heated } from '@assets/icons/categories/heated'
import { AdaCompliant } from '@assets/icons/features-and-amenities/ada-compliant'
import { Backyard } from '@assets/icons/features-and-amenities/backyard'
import { BallMachine } from '@assets/icons/features-and-amenities/ball-machine'
import { Basement } from '@assets/icons/features-and-amenities/basement'
import { Basketball } from '@assets/icons/features-and-amenities/basketball'
import { BrickOven } from '@assets/icons/features-and-amenities/brick-oven'
import { DiningArea } from '@assets/icons/features-and-amenities/dining-area'
import { DivingBoard } from '@assets/icons/features-and-amenities/diving-board'
import { FirePit } from '@assets/icons/features-and-amenities/fire-pit'
import { GameRoom } from '@assets/icons/features-and-amenities/game-room'
import { Garage } from '@assets/icons/features-and-amenities/garage'
import { General } from '@assets/icons/features-and-amenities/general'
import { GreatSunlight } from '@assets/icons/features-and-amenities/great-sunlight'
import { Grill } from '@assets/icons/features-and-amenities/grill'
import { Grotto } from '@assets/icons/features-and-amenities/grotto'
import { HeatedPool } from '@assets/icons/features-and-amenities/heated-pool'
import { HotTub } from '@assets/icons/features-and-amenities/hot-tub'
import { Indoor } from '@assets/icons/features-and-amenities/indoor'
import { Instructor } from '@assets/icons/features-and-amenities/instructor'
import { KiddiePool } from '@assets/icons/features-and-amenities/kiddie-pool'
import { Kitchen } from '@assets/icons/features-and-amenities/kitchen'
import { LargeShallowArea } from '@assets/icons/features-and-amenities/large-shallow-area'
import { LivingRoom } from '@assets/icons/features-and-amenities/living-room'
import { MediaRoom } from '@assets/icons/features-and-amenities/media-room'
import { MeetingSpace } from '@assets/icons/features-and-amenities/meeting-space'
import { MixedSpace } from '@assets/icons/features-and-amenities/mixed-space'
import { NightLighting } from '@assets/icons/features-and-amenities/night-lighting'
import { Other } from '@assets/icons/features-and-amenities/other'
import { Outdoor } from '@assets/icons/features-and-amenities/outdoor'
import { Paddles } from '@assets/icons/features-and-amenities/paddles'
import { Patio } from '@assets/icons/features-and-amenities/patio'
import { Pickleball } from '@assets/icons/features-and-amenities/pickleball'
import { Playground } from '@assets/icons/features-and-amenities/playground'
import { PoolBasketballHoop } from '@assets/icons/features-and-amenities/pool-basketball-hoop'
import { PoolToys } from '@assets/icons/features-and-amenities/pool-toys'
import { RoofDeck } from '@assets/icons/features-and-amenities/roof-deck'
import { Sauna } from '@assets/icons/features-and-amenities/sauna'
import { ShadedArea } from '@assets/icons/features-and-amenities/shaded-area'
import { Shower } from '@assets/icons/features-and-amenities/shower'
import { Speakers } from '@assets/icons/features-and-amenities/speakers'
import { SwimmingLanes } from '@assets/icons/features-and-amenities/swimming-lanes'
import { TanningEdge } from '@assets/icons/features-and-amenities/tanning-edge'
import { Tennis } from '@assets/icons/features-and-amenities/tennis'
import { TennisBalls } from '@assets/icons/features-and-amenities/tennis-balls'
import { Towels } from '@assets/icons/features-and-amenities/towels'
import { Tv } from '@assets/icons/features-and-amenities/tv'
import { Volleyball } from '@assets/icons/features-and-amenities/volleyball'
import { Water } from '@assets/icons/features-and-amenities/water'
import { Waterfall } from '@assets/icons/features-and-amenities/waterfall'
import { Waterslide } from '@assets/icons/features-and-amenities/waterslide'
import { Wifi } from '@assets/icons/features-and-amenities/wifi'
import { Workspace } from '@assets/icons/features-and-amenities/workspace'
import { ScenicViews } from '@assets/icons/scenic-views'
import { ColdPlunge } from '@assets/icons/search/filters/cold-plunge'
import { Pool } from '@assets/icons/spaces/pool'
import { BarResturant } from '@assets/icons/use-cases/bar-resturant'

/**
 * This is the source of truth for amenity icons
 */
const listingFeatureAndAmenityIcons: Record<
  string, // <- wish this was an enum from backend
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  adaCompliant: AdaCompliant,
  general: General,
  other: Other,
  bbqGrill: Grill,
  brickOven: BrickOven,
  stoveOven: BrickOven,
  firePit: FirePit,
  greatSunlight: GreatSunlight,
  grill: Grill,
  grotto: Grotto,
  heated: HeatedPool,
  heatedPool: HeatedPool,
  hotTub: HotTub,
  kiddiePool: KiddiePool,
  shallowArea: LargeShallowArea,
  largeShallowArea: LargeShallowArea,
  nightLighting: NightLighting,
  playground: Playground,
  poolBasketballHoop: PoolBasketballHoop,
  poolHoop: PoolBasketballHoop,
  poolToys: PoolToys,
  sauna: Sauna,
  saunaOn: Sauna,
  shadedArea: ShadedArea,
  speakers: Speakers,
  swimmingLanes: SwimmingLanes,
  tanningEdge: TanningEdge,
  towels: Towels,
  waterfall: Waterfall,
  waterSlide: Waterslide,
  wifi: Wifi,
  wiFi: Wifi,

  // new icons
  ball: Basketball,
  backyard: Backyard,
  basement: Basement,
  diningArea: DiningArea,
  divingBoard: DivingBoard,
  gameRoom: GameRoom,
  garage: Garage,
  kitchen: Kitchen,
  livingRoom: LivingRoom,
  mediaRoom: MediaRoom,
  meetingSpace: MeetingSpace,
  patio: Patio,
  roofDeck: RoofDeck,
  tVs: Tv,
  tvs: Tv,
  workspace: Workspace,
  hotTubOn: HotTub,
  shower: Shower,
  racquets: Tennis,
  balls: TennisBalls,
  ballMachine: BallMachine,
  water: Water,
  paddles: Paddles,
  instructor: Instructor,
  tennisCourt: Tennis,
  volleyballCourt: Volleyball,
  basketballCourt: Basketball,
  pickleballCourt: Pickleball,
  indoor: Indoor,
  outdoor: Outdoor,
  mixedSpace: MixedSpace,
  pool: Pool,
  coldPlunge: ColdPlunge,

  loungeChairs: LoungeChairs,
  largeYard: Backyard,
  speakersSoundSystem: Speakers,
  tv: Tv,
  miniFridge: MiniFridge,
  standardChairs: SittingArea,
  heating: HeatedPool,
  towelsProvided: Towels,
  outdoorHeater: Heated,
  poolLighting: NightLighting,
  firepit: FirePit,
  greatViews: ScenicViews,
  eatingTable: DiningArea,
  outdoorBar: BarResturant,
  cooler: MiniFridge,
}

const proHostDescription =
  'Prohosts are experienced, top-rated hosts with several seasons of hosting under their belt, committed to providing great swim experiences for guests.'

export const listingModulesConstants = {
  listingFeatureAndAmenityIcons,
  proHostDescription,
}
